/** @jsxImportSource @emotion/react */

import React from 'react';
import styled from 'styled-components';
import Content from '@component/common/content';
import * as size from '@constant/size';
import * as color from '@constant/color';
import SideTab from '@component/moashelf/navigator/side-tab';
import Shelf from '@component/moashelf/newsletter/shelf';
import BottomTab from '@component/moashelf/navigator/bottom-tab';
import { IS_IYAGIGO_MOBILE_VIEW } from '@config/environment';
import { useParams } from 'react-router-dom';

const ShelfPage: React.FC<any> = () => {
  const { shelfKey } = useParams();

  if (!shelfKey) {
    throw new Error('shelfKey is not found');
  }

  return (
    <>
      {!IS_IYAGIGO_MOBILE_VIEW && <SideTab />}
      <Content
        left={IS_IYAGIGO_MOBILE_VIEW ? '0px' : size.WEB_SIDE_WIDTH}
        top={'0px'}
        bottom={IS_IYAGIGO_MOBILE_VIEW ? size.MOBILE_BOTTOM_HEIGHT : '0px'}>
        <Shelf shelfKey={shelfKey} />
      </Content>
      {IS_IYAGIGO_MOBILE_VIEW && <BottomTab />}
    </>
  );
};

export default ShelfPage;
